const state = () => ({
    searchInfo: null,
});

const getters = {
    getSearchData: state => state.searchInfo,
};

const actions = {
    // 로그인 정보저장
    setSearchData({commit}, data){
        commit('SET_SEARCH_DATA', data);
    }
};

const isSameSearchData = (prev, next) => {
    if (prev === next) return true;
    if (!prev || !next) return false;
    return (
        prev.id == next.id &&
        prev.macAddress === next.macAddress &&
        prev.storeId == next.storeId &&
        prev.productSn === next.productSn &&
        prev.modelCode === next.modelCode &&
        prev.outModelCode === next.outModelCode
    );
};

const mutations = {
    SET_SEARCH_DATA(state, payload) {
        if (isSameSearchData(state.searchInfo, payload)) {
            return;
        }
        state.searchInfo = payload;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
 